import type { useNavigate } from 'react-router-dom';
import { NOT_APPROVED, signOutNotApproved } from './apiError.js';

const API = import.meta.env.VITE_API_URL;

/** fetch() with the stored access token; refreshes it once on 401, else sends the user to /login. */
export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {},
  navigate: ReturnType<typeof useNavigate>,
): Promise<Response> => {
  let token = localStorage.getItem('velinko_token');
  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  let res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    const refreshToken = localStorage.getItem('velinko_refresh_token');
    if (!refreshToken) {
      localStorage.removeItem('velinko_token');
      navigate('/login');
      return res;
    }

    try {
      const refreshRes = await fetch(`${API}/auth/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
      });

      if (refreshRes.ok) {
        const { data } = await refreshRes.json();
        localStorage.setItem('velinko_token', data.accessToken);
        localStorage.setItem('velinko_refresh_token', data.refreshToken);
        token = data.accessToken;

        headers.set('Authorization', `Bearer ${token}`);
        res = await fetch(url, { ...options, headers });
      } else if (refreshRes.status === 403) {
        signOutNotApproved(navigate);
      } else {
        localStorage.removeItem('velinko_token');
        localStorage.removeItem('velinko_refresh_token');
        navigate('/login');
      }
    } catch {
      localStorage.removeItem('velinko_token');
      localStorage.removeItem('velinko_refresh_token');
      navigate('/login');
    }
  }
  if (res.status === 403) {
    const body = (await res.clone().json().catch(() => null)) as { code?: string } | null;
    if (body?.code === NOT_APPROVED) signOutNotApproved(navigate);
  }
  return res;
};
